import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined'
import { Badge } from '@mui/material'
import {
  ChatbotMessageReportDynamicFilterField,
  ChatbotMessageReportStatus,
  DynamicFilterItemOperation,
  DynamicFilterOperator,
  useAllChatbotMessageReportsQuery
} from 'types'

const POLL_INTERVAL = 300_000

// Count of open (pending + in review) reports awaiting triage.
const OPEN_REPORTS_FILTER = [
  {
    operator: DynamicFilterOperator.And,
    items: [
      {
        field: ChatbotMessageReportDynamicFilterField.Status,
        operation: DynamicFilterItemOperation.In,
        value: `${ChatbotMessageReportStatus.Pending},${ChatbotMessageReportStatus.InReview}`
      }
    ]
  }
]

export const ChatbotMessageReportsSidebarIcon = () => {
  const { data } = useAllChatbotMessageReportsQuery({
    variables: { page: 1, perPage: 1, dynamicFilters: OPEN_REPORTS_FILTER },
    pollInterval: POLL_INTERVAL,
    fetchPolicy: 'cache-and-network'
  })

  const openCount = data?.allChatbotMessageReports.totalCount ?? 0

  return (
    <Badge badgeContent={openCount} color="primary">
      <FlagOutlinedIcon />
    </Badge>
  )
}
